import React from "react";
import Support from "../../store/SupportTab";
import SupportNew from "./Support";
import { useTranslation } from "react-i18next";

const GeneralSupportTab = (props: any) => {
    const { t: tLang } = useTranslation();

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1>{tLang("supportSection.supportTitleText")}</h1>
                </div>
            </div>

            <Support selectedTab="1" />
            {<SupportNew setForm="" setSupportIdentityThreatState="" supportIdentityThreatState="" onClose="" />}
        </React.Fragment>
    );
};

export default GeneralSupportTab;
